import { createSelector } from '@ngrx/store';
import { SearchResponse } from '~app/modules/catalog/models';
import { getCatalogState } from '../feature.selector';
import { CatalogState } from '../state';

export const getProductsPayload = createSelector(
  getCatalogState,
  (state: CatalogState) => state && state.products.payload,
);

export const getProducts = createSelector(getProductsPayload,
  (payload) => payload && payload.products && payload.products.items);

export const getLastRequestFilterParameters = createSelector(getCatalogState,
  (state: CatalogState) => state.products.currentFilter);

export const getProductsTotalCount = createSelector(getProductsPayload,
  (payload: SearchResponse) => payload && payload.products && payload.products.totalCount);

export const isProductsLoading = createSelector(getCatalogState,
  (state: CatalogState) => state?.products?.loading
);
export const getProductsErrorDetails = createSelector(getCatalogState,
  (state: CatalogState) => state && state.products && state.products.error && state.products.error.detail
);
//No Food Result
export const shouldShowNoFoodResult = createSelector(getProductsPayload, (payload: SearchResponse) => {
  return payload && payload.metaData && payload.metaData.hasFood;
});

//Search correction
export const getSearchCorrection = createSelector(getProductsPayload, (payload: SearchResponse) => {
  return payload && payload.correction;
});

//Recommended products
export const getRecommendedProducts = createSelector(getProductsPayload, (payload: SearchResponse) => {
  return payload && payload.recommendedProducts && payload.recommendedProducts.items;
});

export const getRecommendedProductsType = createSelector(getProductsPayload, (payload: SearchResponse) => {
  return payload && payload.recommendedProducts && payload.recommendedProducts.type;
});
